export  const initialData = [
    //19.02.2026
    {
        key: '1',
        fullName: 'Abdurazakov Rustam Kayumov',
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000018',
        url: 'https://test.tdtu.uz/storage/pages/February2026/xFiAKAC362XmKVi2LBS2.pdf'
    },
    {
        key: '2',
        fullName: "Samadov Mirshoxid Miroqil o'g'li",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000019',
        url: 'https://test.tdtu.uz/storage/pages/February2026/kga7wRtgYuNCramaCLGw.pdf'
    },
    {
        key: '3',
        fullName: "Samatov Mirakbar Mirakilovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000020',
        url: 'https://test.tdtu.uz/storage/pages/February2026/FJHrEUrEyfJ2VIXkpOmS.pdf'
    },
    {
        key: '4',
        fullName: 'Mustafoyev Azizjon Olimjonovich',
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000021',
        url: 'https://test.tdtu.uz/storage/pages/February2026/CQW4P8s5iuW0cbiqabz3.pdf'
    },
    {
        key: '5',
        fullName: 'Jabborov Dilshod Muxtorovich',
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000022',
        url: 'https://test.tdtu.uz/storage/pages/February2026/tZoYJlXBlx4P3j2cl0dR.pdf'
    },
    {
        key: '6',
        fullName: "Abdullabekova Dilafruz Rustamjon qizi",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000023',
        url: 'https://test.tdtu.uz/storage/pages/February2026/mN8POlc5AYFXFL5D4DCz.pdf'
    },
    {
        key: '7',
        fullName: "Shukurullayev Sarvar Anvar o'g'li",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000024',
        url: 'https://test.tdtu.uz/storage/pages/February2026/XIUGX80AWcCbbpplkdOL.pdf'
    },
    {
        key: '8',
        fullName: "Vahabov Azizbek Toxir o'g'li",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000025',
        url: 'https://test.tdtu.uz/storage/pages/February2026/WyiMsWcCaGD7QjKMvr0n.pdf'
    },
    {
        key: '9',
        fullName: "Xaitmuradov Bobir Olimovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000026',
        url: 'https://test.tdtu.uz/storage/pages/February2026/Fsxh0rtikdjbwYDXjrAv.pdf'
    },
    {
        key: '10',
        fullName: "Yaqubov Zafarjon Xakimovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000027',
        url: 'https://test.tdtu.uz/storage/pages/February2026/bSeByM8JO12sZIqcc1Co.pdf'
    },
    {
        key: '11',
        fullName: "Axmedov Ahmad Maxmudjonovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000028',
        url: 'https://test.tdtu.uz/storage/pages/February2026/SfWP8h9eKfAH4Wdg8yzO.pdf'
    },
    {
        key: '12',
        fullName: "Unarov Abdurauf Norbayevich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000029',
        url: 'https://test.tdtu.uz/storage/pages/February2026/Bhz11jqz8nA9YmeBPEKM.pdf'
    },
    {
        key: '13',
        fullName: "Xolmuminov Shaxboz Ravshan o'g'li",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000030',
        url: 'https://test.tdtu.uz/storage/pages/February2026/mGnz1ZAmXnF09bfKtbW5.pdf'
    },
    {
        key: '14',
        fullName: "Xalilov Sherzodbek Alijonovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000031',
        url: 'https://test.tdtu.uz/storage/pages/February2026/ViSaRsRYMDsbwHU3SSFd.pdf'
    },
    {
        key: '15',
        fullName: "Badalova Dildora Abdumalikovna",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000032',
        url: 'https://test.tdtu.uz/storage/pages/February2026/4li6GPNfBdk6SxXg2IXR.pdf'
    },
   //05.03.2026
    {
        key: '16',
        fullName: "Kurbonov Orifxon Obidovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000033',
        url: 'https://test.tdtu.uz/storage/pages/March2026/jO3jX61DTTFunUQzrrSI.pdf'
    },
    {
        key: '17',
        fullName: "Samoylenko Mixaylo Yuriyovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000034',
        url: 'https://test.tdtu.uz/storage/pages/March2026/Fc4WKdtyBT5JV2TOqfJW.pdf'
    },
    {
        key: '18',
        fullName: "Jalolov Shaxzod Raim o'g'li",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000035',
        url: 'https://test.tdtu.uz/storage/pages/March2026/DG4Zgrtyw97MZXm0bLAb.pdf'
    },
    {
        key: '19',
        fullName: "Jumamuratov Kunxoja Mirzamurat uli",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000036',
        url: 'https://test.tdtu.uz/storage/pages/March2026/RHTtKfItT778h13AjCro.pdf'
    },
    {
        key: '20',
        fullName: "Orazimbetov Baburbek Ramatulla uli",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000037',
        url: 'https://test.tdtu.uz/storage/pages/March2026/FOUkaJ9y4VAo7GzhyEq4.pdf'
    },
    {
        key: '21',
        fullName: "Kozlenko Andrey Vladimirovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000038',
        url: 'https://test.tdtu.uz/storage/pages/March2026/ujxyMmlGYQjvt11p5mZW.pdf'
    },
    {
        key: '22',
        fullName: "Perova Yelizaveta Andreyevna",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000039',
        url: 'https://test.tdtu.uz/storage/pages/March2026/e9wNGoNw8RGf8CfUkuyn.pdf'
    },
    {
        key: '23',
        fullName: "Prokudina Kristina Aleksandrovna",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000040',
        url: 'https://test.tdtu.uz/storage/pages/March2026/0Smk87jNWhcAiCnKyW8P.pdf'
    },
    {
        key: '24',
        fullName: "Otamurodov Sardor Ilxomovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000041',
        url: 'https://test.tdtu.uz/storage/pages/March2026/IB7djOnDMPZtPoiZw8Wd.pdf'
    },
    {
        key: '25',
        fullName: "Uzoqov Husan Zokirovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000042',
        url: 'https://test.tdtu.uz/storage/pages/March2026/FoB1vQTo7em0POfYopYq.pdf'
    },
    {
        key: '26',
        fullName: "Yakubov Abrar Tulkunovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000043',
        url: 'https://test.tdtu.uz/storage/pages/March2026/8ODTYOSG5Kryd4E7YrTU.pdf'
    },
    {
        key: '27',
        fullName: "Norimov Sherali Komilovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000044',
        url: 'https://test.tdtu.uz/storage/pages/March2026/QvtGOSYKpsL6bSdffTNG.pdf'
    },
    {
        key: '28',
        fullName: "Eshdavlatov Utkir Norboboyevich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000045',
        url: 'https://test.tdtu.uz/storage/pages/March2026/xORj2ILWBKZz5J0v4IUt.pdf'
    },
    {
        key: '29',
        fullName: "Masharipov Ilhomboy Ikrom o'g'li",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000046',
        url: 'https://test.tdtu.uz/storage/pages/March2026/jG76NXtjvVBv0gQ2GrWi.pdf'
    },
    {
        key: '30',
        fullName: "Urinov Abror Botirovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000047',
        url: 'https://test.tdtu.uz/storage/pages/March2026/zYpM4tltt1A2BZa4SFUv.pdf'
    },
    {
        key: '31',
        fullName: "Nimatullayev Zafar Sunatullayevich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000048',
        url: 'https://test.tdtu.uz/storage/pages/March2026/8WQECqAmkq9MGu5GPeyO.pdf'
    },
    {
        key: '32',
        fullName: "Nimatullayev Sarvar Sunatullayevich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000049',
        url: 'https://test.tdtu.uz/storage/pages/March2026/irg11PPeuuyWHvnXFshp.pdf'
    },
    {
        key: '33',
        fullName: "Nabiyev Uygun Muradaliyevich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000050',
        url: 'https://test.tdtu.uz/storage/pages/March2026/LaUDNYNZhYmVVSXPIKFT.pdf'
    },
    {
        key: '34',
        fullName: "Muxtarov Odilxon Arslanovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000051',
        url: 'https://test.tdtu.uz/storage/pages/March2026/ad9OMv2Cx63A3j5FiaCL.pdf'
    },
    {
        key: '35',
        fullName: "Qozixonov Madixon Tolibxon o'g'li",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000052',
        url: 'https://test.tdtu.uz/storage/pages/March2026/zuFKjbcEwqIKUKH9N22L.pdf'
    },
    {
        key: '36',
        fullName: "Jumaboyev Humayun Qahramonovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000017',
        url: 'https://test.tdtu.uz/storage/pages/March2026/QPwPh3nP4TjKUEjYZKNe.pdf'
    },
];